// extracted by mini-css-extract-plugin
export var mt0 = "fp-uD";
export var mt1 = "fp-vD";
export var mt2 = "fp-wD";
export var mt3 = "fp-xD";
export var mt4 = "fp-yD";
export var mt5 = "fp-zD";
export var mt6 = "fp-AD";
export var widgetMarkdown = "fp-BD";
export var widgetMarkdown__markdown = "fp-CD";